import { MoveGenerator } from '../../jscaip/AI/AI';
import { Ordinal } from '../../jscaip/Ordinal';
import { PlayerOrNone } from '../../jscaip/Player';
import { TeekoDropMove, TeekoTranslationMove } from './TeekoMove';
export class TeekoMoveGenerator extends MoveGenerator {
    getListMoves(node, config) {
        if (node.gameState.isInDropPhase()) {
            return this.getListDrops(node.gameState);
        }
        else {
            return this.getListTranslations(node.gameState, config);
        }
    }
    getListDrops(state) {
        const moves = [];
        for (const coordAndContent of state.getCoordsAndContents()) {
            const coord = coordAndContent.coord;
            if (coordAndContent.content.isNone()) {
                const newMove = TeekoDropMove.from(coord);
                moves.push(newMove);
            }
        }
        return moves;
    }
    getListTranslations(state, config) {
        const moves = [];
        const currentPlayer = state.getCurrentPlayer();
        const piecePositions = this.getCoordsContaining(state, currentPlayer);
        for (const start of piecePositions) {
            for (const target of this.getPossibleTargets(state, start, config)) {
                const newMove = TeekoTranslationMove.from(start, target).get();
                moves.push(newMove);
            }
        }
        return moves;
    }
    getPossibleTargets(state, start, config) {
        if (config.teleport) {
            return this.getCoordsContaining(state, PlayerOrNone.NONE);
        }
        else {
            const possibleTargets = [];
            for (const direction of Ordinal.factory.all) {
                const target = start.getNext(direction);
                if (state.isEmptyAt(target)) {
                    possibleTargets.push(target);
                }
            }
            return possibleTargets;
        }
    }
    getCoordsContaining(state, piece) {
        const coords = [];
        for (const coordAndContent of state.getCoordsAndContents()) {
            if (coordAndContent.content === piece) {
                coords.push(coordAndContent.coord);
            }
        }
        return coords;
    }
}
